export function gerarMesesDoFiltro(startDate, endDate) {
  if (!startDate || !endDate) return [];

  const [startYear, startMonth] = startDate.split("-");
  const [endYear, endMonth] = endDate.split("-");

  const atual = new Date(Number(startYear), Number(startMonth) - 1, 1);
  const limite = new Date(Number(endYear), Number(endMonth) - 1, 1);
  const meses = [];

  while (atual <= limite) {
    const mesStr = atual
      .toLocaleString("pt-BR", { month: "short" })
      .replace(".", "")
      .slice(0, 3);
    const anoStr = atual.getFullYear();
    meses.push(`${mesStr}/${anoStr}`);
    atual.setMonth(atual.getMonth() + 1);
  }

  return meses.reverse();
}

export function getMockHistoricoValue(rowIdx, colIdx) {
  const seed = (rowIdx + 1) * 1000 + (colIdx + 1) * 137;
  return Math.floor((seed % 4900) + 100);
}

export function formatNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") return value.toLocaleString("pt-BR");
  const str = String(value);
  const num = Number(str.replace(/\./g, "").replace(",", "."));
  if (Number.isNaN(num)) return str;
  return num.toLocaleString("pt-BR");
}
